<template>
  <div style="overflow: hidden; position: relative">
    <vs-row class="py-4 modal-wrapper">
      <vs-col vs-justify="center" vs-align="center" vs-w="6" class="mb-4">
        انتخاب دسته بندی
        <vs-select class="mt-1" v-model="category" width="100%">
          <vs-select-item
            v-for="(category, index) in categories"
            :value="category"
            :text="`${index + 1} - ${category.title}`"
            :key="index"
            icon="arrow_downward"
          />
        </vs-select>
      </vs-col>
      <vs-col vs-justify="center" vs-align="center" vs-w="6" class="mb-4">
        نام زیر دسته
        <vs-input
          placeholder="نام زیر دسته"
          v-model="subCategoryClone.title"
          class="w-100 mt-1"
        />
      </vs-col>
      <vs-col
        class="mb-4"
        v-if="!createMode"
        vs-justify="center"
        vs-align="center"
        vs-w="6"
      >
        ترتیب نمایش
        <vs-input
          placeholder="ترتیب نمایش"
          v-model="subCategoryClone.level"
          class="w-100 mt-1"
        />
      </vs-col>
      <vs-col class="mt-1 mb-4" vs-justify="center" vs-align="center" vs-w="12">
        توضیحات زیردسته
        <vs-textarea
          v-model="subCategoryClone.description"
          placeholder="توضیحات زیردسته را اینجا بنویسید..."
          class="w-100 mt-1"
        />
      </vs-col>
      <vs-col class="mt-0 mb-8" vs-justify="center" vs-align="center" vs-w="12">
        <vs-checkbox
          v-model="subCategoryClone.available"
          :value="subCategoryClone.available"
          >موجودیت محصولات این زیردسته</vs-checkbox
        >
      </vs-col>
      <!-- <vs-col vs-justify="center" vs-align="center" vs-w="12">
        <vs-checkbox
          v-model="subCategoryClone.visible"
          :value="subCategoryClone.visible"
          >نمایش زیردسته</vs-checkbox
        >
      </vs-col> -->
    </vs-row>
    <div class="footer">
      <div class="footer-actions">
        <div class="w-full flex-grow max-w-full flex-1 flex-shrink-0">
          <vs-button
            color="primary"
            @click="sendRequest()"
            style="width: 100%"
            className="w-full flex-grow max-w-full flex-1  flex-shrink-0"
            block
            icon-pack="feather"
            icon="icon-check"
            >{{ createMode ? "ایجاد" : "ویرایش" }} زیر دسته</vs-button
          >
        </div>
        <vs-button
          v-if="!createMode"
          @click="remove()"
          class="remove-btn w-full flex-1 px-0"
          color="danger"
          type="border"
          size="small"
        >
          <img
            style="width: 14px; margin-bottom: -4px; margin-left: 4px"
            src="../../assets/icons/trash.svg"
          />
          حذف زیر دسته
        </vs-button>
      </div>
    </div>
  </div>
</template>
<script>
  import productApiService from "./../../services/api/ProductApiService";
  import { mapGetters } from "vuex";

  export default {
    name: "Input",
    data() {
      return {
        subCategoryClone: { ...this.value },
        subCategory: this.value,
        category: this.activeCategory,
        Blob: window.Blob,
      };
    },
    mounted() {
      if (this.createMode)
        this.subCategoryClone = {
          ...this.value,
          available: true,
        };
    },
    computed: {
      ...mapGetters({
        currentProvider: "profile/currentProvider",
      }),
    },
    methods: {
      checkLevel() {
        return this.category.subCategories
          ? this.category.subCategories[this.category.subCategories.length - 1]
            ? +this.category.subCategories[
                this.category.subCategories.length - 1
              ].level + 1
            : 1
          : 1;
      },
      sendRequest() {
        const subCategory = { ...this.subCategoryClone };

        if (this.createMode) subCategory.level = this.checkLevel();

        if (!subCategory.title) {
          this.$vs.notify({
            text: "لطفا تمامی فیلد ها را وارد کنید",
            color: "danger",
            position: "bottom-center",
          });
          return;
        }

        this.$vs.loading();

        productApiService
          .createOrEditCategory(
            this.currentProvider.id,
            subCategory.id,
            subCategory,
            this.category.id
          )
          .then((result) => {
            this.$emit("close");
            this.$emit(
              this.createMode ? "subCategoryAdded" : "subCategoryUpdated",
              result.resource,
              this.category
            );
            this.$vs.notify({
              text: "عملیات با موفقیت انجام شد.",
              color: "success",
              position: "bottom-center",
            });
          })
          .catch((err) => {
            this.$vs.notify({
              text: err.getErrorDescriptions(),
              color: "danger",
              position: "bottom-center",
            });
          })
          .finally(() => {
            this.$vs.loading.close();
          });
      },
      remove() {
        this.$emit("delete");
        this.$emit("close");
      },
    },
    watch: {
      subCategory(selectedCategory) {
        if (!this.createMode) {
          this.subCategoryClone = { ...selectedCategory };
        }
      },
    },
    props: {
      value: {
        type: Object,
      },
      categories: {
        type: Array,
        required: true,
      },
      createMode: {
        type: Boolean,
        default: false,
      },
      activeCategory: {
        type: Object,
      },
    },
  };
</script>

<style scoped lang="scss">
  .modal-wrapper {
    position: relative;
    padding-bottom: 28px;
    max-height: 700px;
    overflow-y: scroll;
  }

  .footer {
    z-index: 100;
    background-color: #fff;
    padding: 1rem 0 0;

    .footer-actions {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.75rem;

      @media (max-width: 768px) {
        flex-direction: column;
      }
    }
    .footer-submit-wrap {
      padding: 0;
      margin: 0;
      width: 100%;
    }

    .remove-btn {
      height: 42px;
      font-size: 14px;
      max-width: 50%;

      @media (max-width: 768px) {
        max-width: 100%;
        width: 100%;
      }
    }
  }
</style>
